import { render } from "./MessagesChatInvitation.vue?vue&type=template&id=1a1d5354&scoped=true"
import script from "./MessagesChatInvitation.vue?vue&type=script&lang=js"
export * from "./MessagesChatInvitation.vue?vue&type=script&lang=js"

import "./MessagesChatInvitation.vue?vue&type=style&index=0&id=1a1d5354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1d5354"]])

export default __exports__